import { CalendarWeekIcon } from './CalendarWeekIcon';

/**
 * author: Simran
 * id F2D23B1E-EA12-4EF5-9365-E698D1CD1319
 * name calendar-week
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-week.svg
 * tags
 * - Date / Time 
 */
export const EventWeekIcon = CalendarWeekIcon;
export default EventWeekIcon